// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1eIUv","label":"Radio_label__3b71r","checkMark":"Radio_checkMark__vzw1I","disabled":"Radio_disabled__E3GW2"};